export default "__VITE_ASSET__BKVhTWFk__"